const HOLLYWOODSTUDIOSLANDS = [
    {
        name: 'Animation Courtyard',
        rides: [
            {
                name: 'BB-8 Astromech on Duty',
                count: 0
            },
            {
                name: 'Star Wars Launch Bay: Meet Chewbacca',
                count: 0,
            },
            {
                name: 'Voyage of the Little Mermaid',
                count: 0,
            },
            {
                name: 'Walt Disney Presents',
                count: 0,
            }
        ]
    },
    {
        name: 'Echo Lake',
        rides: [
            {
                name: 'For the First Time in Forever',
                count: 0,
            },
            {
                name: 'Indiana Jones Epic Stunt Spectacular!',
                count: 0,
            },
            {
                name: 'Jedi Training: Trials of the Temple',
                count: 0
            },
            {
                name: 'Star Tours: The Adventures Continue',
                count: 0
            }
        ]
    },

    {
        name: 'Grand Avenue',
        rides: [
            {
                name: 'Muppet*Vision 3D',
                count: 0
            }
        ]
    },

    {
        name: 'Hollywood Boulevard',
        rides: [
            {
                name: "Mickey and Minnie's Runaway Railway",
                count: 0
            }
        ]
    },

    {
        name: "Star Wars: Galaxy's Edge",
        rides: [
            {
                name: 'Droid Depot',
                count: 0,
            },
            {
                name: 'Millennium Falcon',
                count: 0,
            },
            {
                name: "Savi's Workshop",
                count: 0,
            },
            {
                name: 'Star Wars: Rise of the Resistance',
                count: 0
            }
        ]
    },

    {
        name: 'Sunset Boulevard',
        rides: [
            {
                name: 'Beauty and the Beast - Live on Stage',
                count: 0,
            },
            {
                name: 'Fantasmic!',
                count: 0,
            },
            {
                name: "Lightning McQueen's Racing Academy",
                count: 0,
            },
            {
                name: "Rock'n'Roller Coaster Starring Aerosmith",
                count: 0,
            },
            {
                name: 'The Twilight Zone Tower of Terror',
                count: 0,
            }
        ]
    },

    {
        name: 'Toy Story Land',
        rides: [
            {
                name: 'Alien Swiling Saucers',
                count: 0,
            },
            {
                name: 'Slinky Dog Dash',
                count: 0
            },
            {
                name: 'Toy Story Mania!',
                count: 0,
            }
        ]
    }
]

export default HOLLYWOODSTUDIOSLANDS;